import { useAuth } from "@/auth";

class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export function useAdminApi() {
  const { authorizedFetch } = useAuth();

  async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
    const res = await authorizedFetch(path, init);
    if (!res.ok) {
      let errorBody: { error?: string } = {};
      try {
        errorBody = (await res.json()) as { error?: string };
      } catch {
        /* ignore */
      }
      throw new ApiError(errorBody.error ?? `${path} ${res.status}`, res.status);
    }
    return (await res.json()) as T;
  }

  return {
    get: <T>(path: string) => request<T>(path, { method: "GET" }),
    post: <T>(path: string, body?: unknown) => {
      const init: RequestInit =
        body !== undefined
          ? {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(body),
            }
          : { method: "POST" };
      return request<T>(path, init);
    },
    patch: <T>(path: string, body: unknown) =>
      request<T>(path, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }),
  };
}
